module.exports = __webpack_public_path__ + "img/eye-outline.0a99223c.svg";